const PIXEL_ID = '1018341153869559'

declare global {
  interface Window {
    fbq?: (...args: any[]) => void
    _fbq?: any
  }
}

let initialized = false

/**
 * Injects the Meta Pixel base code, initializes it and fires the initial
 * PageView. Safe to call multiple times — it only runs once.
 */
export function initMetaPixel(): void {
  if (initialized || typeof window === 'undefined') return
  initialized = true

  /* eslint-disable */
  !(function (f: any, b, e, v, n?: any, t?: any, s?: any) {
    if (f.fbq) return
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = !0
    n.version = '2.0'
    n.queue = []
    t = b.createElement(e)
    t.async = !0
    t.src = v
    // Robust insertion: prefer inserting before an existing script, but
    // fall back to appending to <head>/<body> when none exists (sandboxed
    // iframes can have no script tags at init time).
    s = b.getElementsByTagName(e)[0]
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      ;(b.head || b.body || b.documentElement).appendChild(t)
    }
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )
  /* eslint-enable */

  window.fbq?.('init', PIXEL_ID)
  window.fbq?.('track', 'PageView')
}

/**
 * Fires a Meta Pixel AddToCart event. Used on the purchase CTAs that
 * redirect to the Shopify cart.
 */
export function trackAddToCart(params?: {
  value?: number
  currency?: string
  content_name?: string
}): void {
  if (typeof window === 'undefined') return
  window.fbq?.('track', 'AddToCart', {
    content_name: params?.content_name ?? 'El Código del Asado Chileno',
    value: params?.value ?? 6390,
    currency: params?.currency ?? 'CLP',
  })
}
